<template>
	<div class="view-index-h">
		<div class="divider-line"></div>
		<div class="inline-end">
			<el-input v-model="keyWord" @keyup.native="onKeyup"></el-input>
			<img class="search-icon" src="~@/assets/svg/icon-search.svg" @click="onClickSearch" />
		</div>
		<div class="inline-start divider">
			<img class="icon-block" src="~@/assets/png/node-icon.png" />
			<img ref="search-caption-landmark" class="list-icon" src="~@/assets/list-icon.png" />
			<div class="inline-column caption">
				<span class="zh">搜索结果</span>
				<div class="en">SEARCH RESULT  <span>------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------</span></div>
			</div>
			<i class="el-icon-arrow-down"></i>
		</div>
		<div class="search-list">
			<div class="list-caption">找到约{{listData.length}}条记录</div>
			<div class="search-item" v-for="(item, idx) in listData" :key="idx" @click="onItemClick(item)">
				<div class="inline-between inner">
					<div class="content" v-html="item.aname"></div>
					<i class="el-icon-d-arrow-right"></i>
				</div>
			</div>
			<!-- <copy-right /> -->
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import IndexMixin from './mixins/index.js';
	import CopyRight from '@/components/copyRight';
	export default {
		name: 'IndexH',
		mixins: [IndexMixin],
		components: {
			CopyRight
		},
		data() {
			return {
				leftMenuBlockPos: 100
			}
		},
		computed: {
			...mapGetters(["scaleRate"]),
		},
		watch:{
		  
		},
		mounted() {
			
		},
		methods: {
			onKeyup(e) {
				if(e.key == 'Enter') {
					this.onClickSearch();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.view-index-h {
		width: 100%;
		height: 100%;
		position: relative;
		display: flex;
		flex-direction: column;
		
		.divider-line {
			position: absolute;
			border-right: 1px dashed rgb(49, 75, 137);
			width: calc(10px * var(--scale-rate));
			left: 0;
			top: 0;
			bottom: calc(50px * var(--scale-rate));
		}
		
		.main-container {
			border: 1px solid #000000;
			width: calc(100% - 10px * var(--scale-rate));
			height: 100%;
		}
		
		::v-deep {
			.el-input {
				width: calc(210px * var(--scale-rate));
				border-bottom: 1px solid rgba(49, 75, 137, 1); 
				input {
					background: transparent;
					border: none;
					line-height: calc(30px * var(--scale-rate));
					height: calc(30px * var(--scale-rate));
					padding: 0 calc(15px * var(--scale-rate));
					font-size: calc(20px * var(--scale-rate));
					color: #000000;
				}
			}
		}
		.search-icon {
			width: calc(30px * var(--scale-rate));
			height: calc(32px * var(--scale-rate));
		}
		.search-list {
			margin: calc(50px * var(--scale-rate)) calc(115px * var(--scale-rate)) 0
				calc(150px * var(--scale-rate));
			width: calc(100% - (115px + 150px) * var(--scale-rate));
			flex: 1;
			overflow-y: auto;
			overflow-x: hidden;
			
			.list-caption {
				font-size: 14px;
				transform: scale(var(--scale-rate));
				transform-origin: left center;
				height: calc(16px * var(--scale-rate));
				margin-bottom: 20px;
			}
			
			.search-item {
				margin-bottom: calc(20px * var(--scale-rate));
				width: calc(100% / var(--scale-rate));
				height: calc(50px * var(--scale-rate));
				border-bottom: 1px solid rgb(39, 38, 54); 
				cursor: pointer;
				.inner {
					transform: scale(var(--scale-rate));
					transform-origin: left top;
					height: 50px;
					font-size: 20px;
					line-height: 50px;
					font-weight: 300;
				}
				.content {
					span {
						color: rgb(49, 75, 137);
					}
				}
			}
		}
		.divider {
			width: calc(100% - 115px * var(--scale-rate));
			margin-top: calc(30px * var(--scale-rate));
			margin-right: calc(115px * var(--scale-rate));
			overflow: hidden;
			position: relative;
			
			.icon-block {
				width: calc(14px * var(--scale-rate));
				height: calc(14px * var(--scale-rate));
				margin-left: calc(2.5px * var(--scale-rate));
				margin-right: calc(112px * var(--scale-rate));
			}
			
			.el-icon-arrow-down {
				position: absolute;
				right: 0;
			}
			
			.list-icon {
				width: calc(28px * var(--scale-rate));
				height: calc(28px * var(--scale-rate));
				margin-left: calc(7px * var(--scale-rate));
			}
			
			.caption {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-start;
				margin-left: 14px;
				//margin-top: 10px;
				line-height: 1;
				transform: scale(var(--scale-rate));
				transform-origin: left center;
			
				.zh {
					font-size: 25px;
					letter-spacing: 1.4px;
				}
			
				.en {
					width: 100%;
					font-size: 10px;
					letter-spacing: -0.8px;
					color: rgb(39, 38, 54);
					margin-top: 2px;
					margin-left: 55px;
					white-space: nowrap;
					overflow: hidden;
					span {
						letter-spacing: calc(1.4px / var(--scale-rate));
						font-size: calc(10px / var(--scale-rate));
					}
				}
			}
		}
	}
</style>